module.exports = __webpack_public_path__ + "img/SKMJ_ex3.1693792c.jpg";